import ProductCreate from "./ProductCreate";

export default ProductCreate;
